// extracted by mini-css-extract-plugin
export default {"wrapper":"Spin_wrapper__t+Vdw","container":"Spin_container__yg60i"};